import {
  MemberRole,
  SchoolType,
} from '@chegg/wtf-components/dist/types/opencomponents/cheggAuth'
import { User, CitationsJwtError, CitationsJWT } from '@chegg-wt/core/types/auth'
import { NextJsRoute } from '@chegg-wt/core/types/core'
import { createErrorAction } from '@chegg-wt/core/utils/actions'
import { action, createAction, createStandardAction } from 'typesafe-actions'
import { ActionTypes } from './constants'
import { LoadAuthPayload, AuthDataOptions } from './types'
import { AuthSuccessGrant } from './logics'

export interface UserSignupRole {
  memberRole: MemberRole
}

export interface UserSignupSchool {
  schoolType: SchoolType
}

export const setUser = (user: User) => action(ActionTypes.SET_USER, user)
export const setUserError = createErrorAction(ActionTypes.SET_USER_ERROR)

export const fetchUser = createAction(
  ActionTypes.FETCH_USER,
  (action) => (
    redirectTo?: NextJsRoute,
    authType?: AuthSuccessGrant['auth_type'],
    authMethod?: AuthSuccessGrant['auth_method']
  ) => action({ redirectTo }, { authType, authMethod })
)

export const getUser = () => action(ActionTypes.GET_USER)
export const getUserError = createErrorAction(ActionTypes.GET_USER_ERROR)

export const loadCheggAuth = createAction(
  ActionTypes.LOAD_AUTH,
  (action) => (
    defaultflow: LoadAuthPayload['defaultflow'],
    client: string,
    redirectTo?: NextJsRoute,
    authDataOptions?: AuthDataOptions
  ) => action({ defaultflow, client, redirectTo, authDataOptions })
)

export const login = createAction(
  ActionTypes.LOGIN,
  (action) => (saOptions: AuthSuccessGrant, redirectTo: NextJsRoute) =>
    action({ saOptions, redirectTo })
)

export const logout = createStandardAction(ActionTypes.LOGOUT)()
export const logoutFailed = createErrorAction(ActionTypes.LOGOUT_ERROR)
export const authComplete = () => action(ActionTypes.AUTH_COMPLETE)

export const refreshAndFetch = createAction(
  ActionTypes.REFRESH_AND_FETCH,
  (action) => (jwt?: CitationsJWT) => action({}, { jwt })
)

export const upgrade = createStandardAction(ActionTypes.UPGRADE)()

export const upgradeSuccess = createStandardAction(ActionTypes.UPGRADE_SUCCESS)()

export const dataMigrationStatus = createAction(
  ActionTypes.DATA_MIGRATION_STATUS,
  (action) => (inProgress: boolean) => action({ inProgress })
)

export const dataMigrationTick = createStandardAction(ActionTypes.DATA_MIGRATION_TICK)()

export const startDataMigrationTimer = createStandardAction(
  ActionTypes.START_DATA_MIGRATION_TIMER
)()

export const endDataMigrationTimer = createStandardAction(
  ActionTypes.END_DATA_MIGRATION_TIMER
)()

export const handleCorruptToken = createErrorAction<
  typeof ActionTypes.HANDLE_CORRUPT_TOKEN,
  CitationsJwtError
>(ActionTypes.HANDLE_CORRUPT_TOKEN)

/**
 * This saves the data entered by a user
 * at the time of signing up to the app state.
 * This is needed later for firing events after
 * successful signup
 */
export const setSelectedUserSignUpType = createStandardAction(
  ActionTypes.SET_SELECTED_USER_TYPE
)<UserSignupRole>()

export const setSelectedUserSchoolType = createStandardAction(
  ActionTypes.SET_SELECTED_SCHOOL_TYPE
)<UserSignupSchool>()

export const setPaperUploaded = createAction(
  ActionTypes.SET_PAPER_UPLOADED,
  (action) => (setCookie?: boolean) => action({ setCookie })
)
